/* global window */

// Lib
import { useRef, useCallback, useState, useEffect } from 'react';

interface UseDropDownHandlersProps {
  node: HTMLDivElement;
  isDropDownVisible: string | boolean;
  toggleDropDown: VoidFunction;
  closeDropDown: VoidFunction;
  openDropDown: (v?: string | boolean) => void;
  isCloseToBottom: boolean;
}

const useDropDownHandlers = (): UseDropDownHandlersProps => {
  const node: any = useRef();
  const [isDropDownVisible, setDropDownVisibility] = useState<string | boolean>(false);
  const [isCloseToBottom, setDropDownPosition] = useState(false);

  const toggleDropDown = useCallback(() => {
    setDropDownVisibility(!isDropDownVisible);
  }, [setDropDownVisibility, isDropDownVisible]);

  const closeDropDown = useCallback(() => setDropDownVisibility(false), [setDropDownVisibility]);

  const openDropDown = useCallback(
    (value: string | boolean = true) => setDropDownVisibility(value),
    [setDropDownVisibility]
  );

  const handleDropDownPosition = useCallback(() => {
    if (node.current) {
      setDropDownPosition(window.innerHeight - node.current.getBoundingClientRect().bottom < 150);
    }
  }, [node]);

  useEffect(() => {
    handleDropDownPosition();
  }, [node, handleDropDownPosition]);

  return {
    node,
    isDropDownVisible,
    toggleDropDown,
    closeDropDown,
    openDropDown,
    isCloseToBottom,
  };
};

export default useDropDownHandlers;
